<template>
  <div>
    <p>Components content here.</p>
  </div>
</template>

<style scoped>

</style>

<script>
import Components from "./components.ts";
export default Components;
</script>